import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import LatestUpdates from "./components/LatestUpdates";
import HotWorks from "./components/HotWorks";
import CategorySection from "./components/CategorySection";
import AuthorPreview from "./components/AuthorPreview";
import SubscribeSection from "./components/SubscribeSection";
import FaqSection from "./components/FaqSection";
import { faqs } from "@/mocks/comics";

function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-all hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const state = location.state as { scrollToSubscribe?: boolean } | null;
    if (state?.scrollToSubscribe) {
      const t = setTimeout(() => {
        document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        name: "漫蛙漫画网",
        description:
          "漫蛙漫画网专注连载更新与追更提醒，收录最新章节、作品列表、作者专区及系列漫画。",
        inLanguage: "zh-CN",
      },
      {
        "@type": "Organization",
        name: "漫蛙漫画网",
        description: "专注连载更新与追更提醒的中文漫画阅读平台。",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Hero />
      <LatestUpdates />
      <HotWorks />
      <CategorySection />
      <AuthorPreview />
      <SubscribeSection />
      <FaqSection />
      <BackToTop />
    </Layout>
  );
}